import { SortingState } from '@tanstack/react-table';

export const DefaultListingTableSorting: SortingState = [
  { id: 'actions', desc: false },
  { id: 'seating', desc: false },
];

export const DefaultPurchaseTableSorting: SortingState = [
  { id: 'purchaseDate', desc: true },
];
